/* ============================================
   Flip Cards — Touch & keyboard interaction
   assets/flip-cards.js
   ============================================ */

(function () {
  'use strict';

  function initFlipCards() {
    var cards = document.querySelectorAll('.flip-card');

    cards.forEach(function (card) {
      // Skip cards with no back content
      if (card.classList.contains('flip-card--no-back')) return;

      var front = card.querySelector('.flip-card__front');
      var back  = card.querySelector('.flip-card__back');

      var titleEl = card.querySelector('.flip-card__front-title');
      card.setAttribute('tabindex', '0');
      card.setAttribute('role', 'button');
      card.setAttribute(
        'aria-label',
        titleEl ? titleEl.textContent.trim() + ' – antippen zum Umdrehen' : 'Karte umdrehen'
      );

      // Touch only: tap FRONT → flip open
      if (front) {
        front.addEventListener('click', function (e) {
          if (!window.matchMedia('(hover: none)').matches) return;
          card.classList.add('is-flipped');
        });
      }

      // Touch only: tap BACK outside a link/button → flip back
      if (back) {
        back.addEventListener('click', function (e) {
          if (!window.matchMedia('(hover: none)').matches) return;
          if (e.target.closest('a, button, input, select, textarea')) return;
          card.classList.remove('is-flipped');
        });
      }

      // Keyboard: Enter / Space on the card toggles flip
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          card.classList.toggle('is-flipped');
        }
        if (e.key === 'Escape') {
          card.classList.remove('is-flipped');
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFlipCards);
  } else {
    initFlipCards();
  }

  // Re-init after Shopify theme editor section reload
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.classList.contains('section-flip-cards')) {
      initFlipCards();
    }
  });
})();
